module.exports = __webpack_public_path__ + "static/img/Magpies.b3fe405.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Magpies.png
// module id = Mzp/
// module chunks = 1